import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TEmployeeManagementActions } from './employee-management.actions';
import { TEmployeeManagementState, TEmployeeManagementActionType } from './employee-management.models';

export const EMPLOYEE_LIST_FEATURE_KEY = 'employeeList';

export const intialState: TEmployeeManagementState = {
  employeeListingInfo: null,
  deleteEmployeeReplacementsFailure: null,
  employeeListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function employeeManagementReducer(
  state = intialState,
  action: TEmployeeManagementActions,
): TEmployeeManagementState {
  switch (action.type) {
    case TEmployeeManagementActionType.SetEmployeeListPagination:
      return {
        ...state,
        employeeListingPagination: action.pagination,
      };
    case TEmployeeManagementActionType.GetEmployeeList:
      return {
        ...state,
        employeeListingInfo: null,
      };
    case TEmployeeManagementActionType.GetEmployeeListSuccess:
      return {
        ...state,
        employeeListingInfo: {
          res: action.employeeListRes,
          fetchReason: action.fetchReason,
        },
      };
    case TEmployeeManagementActionType.DeleteEmployeeReplacements:
      return {
        ...state,
        deleteEmployeeReplacementsFailure: null,
      };
    case TEmployeeManagementActionType.DeleteEmployeeReplacementsSuccess:
      return {
        ...state,
        deleteEmployeeReplacementsFailure: action.res,
      };
    default:
      return state;
  }
}
